'use client';
import Typography from '@/components/shared/typography/typography.component';
import { useTranslation } from '@/hook';
import { useRouter } from 'next/navigation';
import { FAQsIcon, SellCarBackIcon } from '../../../../public/Images';
import styles from './styles.module.scss';
import Image from 'next/image';

const SellCarMobileHeader = ({
    goBack,
    thankyouReached,
}: {
    goBack?: () => void;
    thankyouReached: boolean;
}) => {
    const router = useRouter();
    const { i18n, t, IS_RTL } = useTranslation();
    const lang = i18n.language;
    const goBackBridge = () => {
        if (goBack) goBack();
    };
    return (
        <div className={styles.header_layout}>
            <button
                className={styles.header_item_layout}
                onClick={() =>
                    thankyouReached
                        ? router.push(`/${lang}/buy-used-cars`)
                        : goBackBridge()
                }
            >
                <Image
                    style={{
                        width: '7px',
                        transform: IS_RTL ? 'scaleX(-1)' : '',
                    }}
                    src={SellCarBackIcon.src}
                    width={SellCarBackIcon.width}
                    height={SellCarBackIcon.height}
                    alt="Back"
                />
                <Typography variant="body1Medium" color={'#002D5D'}>
                    {thankyouReached ? t('browse all cars') : t('Back')}
                </Typography>
            </button>
            <button
                className={styles.header_item_layout}
                onClick={() => router.push(`/${lang}/how-it-works`)}
            >
                <Typography
                    style={{ paddingTop: IS_RTL ? '4px' : '0' }}
                    variant="body1Medium"
                    color={'#667085'}
                >
                    {t('headerMobileFAQs')}
                </Typography>
                <Image
                    style={{ width: '22px' }}
                    src={FAQsIcon.src}
                    width={FAQsIcon.width}
                    height={FAQsIcon.height}
                    alt="Back"
                />
            </button>
        </div>
    );
};

export default SellCarMobileHeader;
